import {Boot} from '@/project'
import VueMeta from 'vue-meta'

/**
 * @link https://vue-meta.nuxtjs.org/
 * @param Vue
 */
const boot: Boot = ({Vue}) => {
  Vue.use(VueMeta)
}

export default boot
